export default __webpack_public_path__ + "static/media/close.3a292d17.png";